import{a as e}from"./chunk-Z5DSCMZ7.mjs";import{b as m}from"./chunk-LSZKOVGW.mjs";import{j as r,k as o}from"./chunk-SGUETU3K.mjs";var i=new r({locale:[e,m,o]});export{i as a};
